
import React from 'react';
import { FileSpreadsheet, Upload, Tag, Package } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ProductUpload from './ProductUpload';
import { ProductTab } from './product/ProductTab';
import { ProductVariationsTab } from './product/ProductVariationsTab';
import { ProductBundlesTab } from './product/ProductBundlesTab';

const ProductManagement = () => {
  const handleUploadComplete = () => {
    // Will be handled by the ProductTab component internally
  };

  return (
    <div>
      <Tabs defaultValue="list">
        <TabsList className="mb-4">
          <TabsTrigger value="list">
            <FileSpreadsheet className="h-4 w-4 mr-2" />
            Product List
          </TabsTrigger>
          <TabsTrigger value="variations">
            <Tag className="h-4 w-4 mr-2" />
            Name Variations
          </TabsTrigger>
          <TabsTrigger value="bundles">
            <Package className="h-4 w-4 mr-2" />
            Bundles
          </TabsTrigger>
          <TabsTrigger value="upload">
            <Upload className="h-4 w-4 mr-2" />
            Upload Products
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="list">
          <ProductTab />
        </TabsContent>

        <TabsContent value="variations">
          <ProductVariationsTab />
        </TabsContent>

        <TabsContent value="bundles">
          <ProductBundlesTab />
        </TabsContent>
        
        <TabsContent value="upload">
          <ProductUpload onUploadComplete={handleUploadComplete} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ProductManagement;
